__turbopack_context__.v({
  "hero": "styles-module__pvXSyq__hero",
  "heroButton": "styles-module__pvXSyq__heroButton",
  "heroContent": "styles-module__pvXSyq__heroContent",
  "heroContentMobileNoMargin": "styles-module__pvXSyq__heroContentMobileNoMargin",
  "heroContentSubtitle": "styles-module__pvXSyq__heroContentSubtitle",
  "heroContentTitle": "styles-module__pvXSyq__heroContentTitle",
  "heroImage": "styles-module__pvXSyq__heroImage",
  "heroImageMobile": "styles-module__pvXSyq__heroImageMobile",
  "heroImageMobileFullHeight": "styles-module__pvXSyq__heroImageMobileFullHeight",
  "heroImageSecondary": "styles-module__pvXSyq__heroImageSecondary",
  "heroImageSecondaryMobile": "styles-module__pvXSyq__heroImageSecondaryMobile",
  "heroImageSecondaryTransparent": "styles-module__pvXSyq__heroImageSecondaryTransparent",
  "heroPicture": "styles-module__pvXSyq__heroPicture",
  "heroSection": "styles-module__pvXSyq__heroSection",
  "heroSimple": "styles-module__pvXSyq__heroSimple",
  "heroSimpleImage": "styles-module__pvXSyq__heroSimpleImage",
  "heroSimpleText": "styles-module__pvXSyq__heroSimpleText",
  "section": "styles-module__pvXSyq__section",
});
